import React, { useEffect, useState } from "react";
import { Col, Label, Row } from "reactstrap";
import "../../assets/scss/pages/_assign-work.scss";
import MultipleDownloadfile from "../common/multiple-downloadfile";
import { setStringFileNameToArray } from "../utils/format-value";
import ConfigData from "../../config.json";
import axios from "axios";
import Swal from "sweetalert2";
import { ConvertFormatDate } from "../utils/convert-date";
import DownloadPDF from "../common/pdf-download";
import { IconLoading } from "../common/popup-alert";

const AssignDetailNda = ({ requestDetail, requestTemplateDetail }) => {
  const accessToken = localStorage.getItem("tkd");
  const [requestType, setRequestType] = useState([]);
  const [subRequestType, setSubRequestType] = useState([]);
  const [userDetail, setUserDetail] = useState([]);
  const [userCreateRequest, setUserCreateRequest] = useState([]);
  const [userBuDetail, setUserBuDetail] = useState([]);
  const [draftDoc, setDraftDoc] = useState([]);
  const [typeOfNda, setTypeOfNda] = useState("");
  const [draftAgreement, setDraftAgreement] = useState("");
  const [considerDoc, setConsiderDoc] = useState([]);

  const optionDdlTypeNda = [
      { value: 1, label: "BU เป็นฝ่ายเปิดเผยข้อมูล (BU as the Disclosing Party)" },
      { value: 2, label: "BU เป็นฝ่ายรับข้อมูล (BU as the Receiving Party)" },
      { value: 3, label: "ต่างฝ่ายต่างเปิดเผยและรับข้อมูล (Both Parties mutually disclose and receive information)" },
  ];

  const draftAgreementOptions = [
    { value: "1", label: "ตรวจสอบสัญญา/บันทึกข้อตกลงตามแนบ (Review draft agreement as attached)" },
    { value: "2", label: "ให้ฝ่ายกฎหมายจัดทำสัญญา/บันทึกข้อตกลง (Draft agreement)" },
  ];

  useEffect(() => {
    showLoading(true);
    LoadRequestType(requestTemplateDetail.id_request_type);
    LoadSubRequestType(requestTemplateDetail.id_sub_request_type);
    LoadUserInfo(requestDetail.request_by);
    LoadUserCreateRequest(requestDetail.create_request_by);

    if (Object.keys(requestTemplateDetail).length > 0) {
      setDraftAgreement(
        draftAgreementOptions.find(
          (item) => item.value === requestTemplateDetail.draft_agreement
        ).label
      );
      setTypeOfNda(
        optionDdlTypeNda.find(
          (item) => item.value === requestTemplateDetail.type_of_nda
        ).label
      );
    }
    LoadAllAttachment();
    showLoading(false);
  }, [requestDetail, requestTemplateDetail]);

  const showLoading = (isShow) => {
    if (isShow) {
      Swal.fire({
        iconHtml: IconLoading,
        title: "Loading...",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  };

  const LoadAllAttachment = () => {
    if (Object.keys(requestTemplateDetail).length > 0) {
      setDraftDoc(setStringFileNameToArray(requestTemplateDetail.draft_doc));
      setConsiderDoc(setStringFileNameToArray(requestTemplateDetail.consider_doc));
    }
  };

  //#region Call APIs

  const LoadRequestType = (requestTypeId) => {
    if (typeof requestTypeId === "undefined" || requestTypeId === null) {
      return;
    }
    let url = ConfigData.API_URL + "request-type/" + requestTypeId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setRequestType(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadSubRequestType = (subRequestTypeId) => {
    if (typeof subRequestTypeId === "undefined" || subRequestTypeId === null) {
      return;
    }
    let url = ConfigData.API_URL + "sub-request-type/" + subRequestTypeId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setSubRequestType(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserInfo = (email) => {
    let url = ConfigData.API_URL + "user/search?email=" + email;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setUserDetail(respData.data[0]);
          LoadUserBuInfo(respData.data[0].id_business_unit);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserBuInfo = (buId) => {
    let url = ConfigData.API_URL + "business-unit/" + buId;
    axios
      .get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        responseType: "json",
      })
      .then((resp) => {
        const respData = resp.data;
        if (respData.is_sucess && respData.data.length > 0) {
          setUserBuDetail(respData.data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const LoadUserCreateRequest = (email) => {
    //console.log(email);
    let url = ConfigData.API_URL + "user/search?status=1&email=" + email;
    let token = "Bearer " + localStorage.getItem("tkd");
    axios.get(url, { headers: { 
        'Authorization' : token ,
    }, responseType: "json" })
    .then(resp => {
        let respData = resp.data;
        // console.log(respData);
        if(respData.is_sucess === true && respData.data.length > 0){
            setUserCreateRequest(respData.data[0]);
        }
    })
    .catch(error => {
        // handlerRespError(error, history);
        console.log(error);
    });
  };

  //#endregion Call APIs

  const SwitchUserDetail = () => {
    switch (userDetail.business_unit?.toLowerCase()) {
      case "bts group holdings public company limited":
        return (
          <>
          {/* <div className="header-content">
              ข้อมูลของผู้ทำคำขอ (User Information)
          </div> */}
          <Col xl={12}>
              <Row>
                  <Col md={10}>
                    <div className="header-content">
                        ข้อมูลของผู้ทำคำขอ (User Information)
                    </div>
                  </Col>
                  <Col md={2}>
                      <div id="section-page-hide-input" className="header-form">
                          <span>
                              <Label htmlFor="export-pdf" className="form-export-file-label">
                                  <i className="mdi mdi-upload i-upload"></i>
                                  Export
                              </Label>
                          </span>
                      </div>
                  </Col>
              </Row>
          </Col>
          <Col md={12}>
            <div className="dashed-line"></div>
            <Row>
              <Col md={5}>
                <div className="body-content">
                  <Label className="content-name">
                    คำขอเลขที่ (Request No.)
                  </Label>
                  <Label className="content-val">
                    {requestDetail.request_no || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    ผู้ทำคำขอ (User’s Request)
                  </Label>
                  <Label className="content-val">
                    {userDetail.name + " " + userDetail.surname || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    บริษัทที่สังกัด (User's BU)
                  </Label>
                  <Label className="content-val">
                    {userBuDetail.name_en || "-"}
                  </Label>
                </div>
              </Col>
              <Col md={2}></Col>
              <Col md={5}>
                <div className="body-content">
                  <Label className="content-name">
                    วันที่สร้างคำขอ (Date of Request)
                  </Label>
                  <Label className="content-val">
                    {requestDetail.request_date || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    อีเมลผู้ทำคำขอ (User’s email)
                  </Label>
                  <Label className="content-val">
                    {userDetail.email || "-"}
                  </Label>
                </div>
                <div className="body-content">
                  <Label className="content-name">
                    แผนกที่สังกัด (User's Department)
                  </Label>
                  <Label className="content-val">
                    {userDetail.department || "-"}
                  </Label>
                </div>
              </Col>
            </Row>
          </Col>
          </>
        );
      default:
        return(
          <>
          <Col xl={12}>
                <Row>
                    <Col md={10}>
                      <div className="header-content">
                          ข้อมูลของผู้ทำคำขอ (User Information)
                      </div>
                    </Col>
                    <Col md={2}>
                        <div id="section-page-hide-input" className="header-form">
                            <span>
                                <Label htmlFor="export-pdf" className="form-export-file-label">
                                    <i className="mdi mdi-upload i-upload"></i>
                                    Export
                                </Label>
                            </span>
                        </div>
                    </Col>
                </Row>
            </Col>
            {/* <div className="header-content">
                ข้อมูลของผู้ทำคำขอ (User Information)
            </div> */}
            <Col md={12}>
              <div className="dashed-line"></div>
              <Row>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      คำขอเลขที่ (Request No.)
                    </Label>
                    <Label className="content-val">
                      {requestDetail.request_no || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      ผู้ทำคำขอ (User’s Request)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.name + " " + userCreateRequest.surname || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      บริษัทที่สังกัด (User's BU)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.business_unit || "-"}
                    </Label>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      วันที่สร้างคำขอ (Date of Request)
                    </Label>
                    <Label className="content-val">
                      {requestDetail.request_date || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      อีเมลผู้ทำคำขอ (User’s email)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.email || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      แผนกที่สังกัด (User's Department)
                    </Label>
                    <Label className="content-val">
                      {userCreateRequest.department || "-"}
                    </Label>
                  </div>
                </Col>
              </Row>
            </Col>
            <div className="header-content">
              ข้อมูลของผู้ประสานงาน (User Coordinator Information)
            </div>
            <Col md={12}>
              <div className="dashed-line"></div>
              <Row>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      ผู้ประสานงาน (User’s Coordinator Request)
                    </Label>
                    <Label className="content-val">
                      {userDetail.name + " " + userDetail.surname || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      บริษัทที่สังกัด (User's BU)
                    </Label>
                    <Label className="content-val">
                      {userBuDetail.name_en || "-"}
                    </Label>
                  </div>
                </Col>
                <Col md={2}></Col>
                <Col md={5}>
                  <div className="body-content">
                    <Label className="content-name">
                      อีเมลผู้ประสานงาน (User’s coordinator email)
                    </Label>
                    <Label className="content-val">
                      {userDetail.email || "-"}
                    </Label>
                  </div>
                  <div className="body-content">
                    <Label className="content-name">
                      แผนกที่สังกัด (User's Department)
                    </Label>
                    <Label className="content-val">
                      {userDetail.department || "-"}
                    </Label>
                  </div>
                </Col>
              </Row>
            </Col>
          </>
        );
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col xl={12} className="mx-auto">
        <DownloadPDF fileName={`form-nda-${requestDetail.request_no}.pdf`} type={"formLabel"} >
          <div className="page-content-assign">
            <Row id="section-page-1-1">
              {SwitchUserDetail()}
              <div className="header-content">
                ข้อมูลทั่วไป (Request General Information)
              </div>
              <Col md={12}>
                <div className="dashed-line"></div>
                <Row>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">ประเภทคำขอ (Type of Request)</Label>
                      <Label className="content-val">
                        {requestType.name_en || "-"}
                      </Label>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">เรื่อง (Matters)</Label>
                      <Label className="content-val">
                        {subRequestType.name_en || "-"}
                      </Label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row id="section-page-2-1">
                  <Col md={12}>
                    <div className="body-content">
                      <Label className="content-name">
                        ชื่อโครงการ (Project Name)
                      </Label>
                      <Label className="content-val word-wrap">
                        {requestTemplateDetail.project_name || "-"}
                      </Label>
                    </div>
                    <div className="body-content">
                      <Label className="content-name">
                        ต้องการให้ฝ่ายกฎหมายดำเนินการ (Request Legal Team to)
                      </Label>
                      <Label className="content-val">{draftAgreement || "-"}</Label>
                    </div>
                    <div className="body-content">
                      <Label className="content-name">เอกสารแนบ (Attachment File)</Label>
                      {draftDoc.length > 0 ? (
                        <MultipleDownloadfile
                          folder={requestDetail.request_no}
                          dataFile={draftDoc}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </div>
                  </Col>
            </Row>
            <Row id="section-page-3-1">
              <Col md={12}>
                <div className="body-content">
                  <Label className="content-name">
                    ทำสัญญาในนามของ (Company Name)
                  </Label>
                  <Label className="content-val">
                    {requestTemplateDetail.name_businessunit || "-"}
                  </Label>
                </div>
              </Col>
            </Row>
            <Row id="section-page-4-1">
              <Col md={12}>
                <Row>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">
                      ประเภท NDA (Type of NDA)
                      </Label>
                      <Label className="content-val">
                        {typeOfNda || "-"}
                      </Label>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">
                      ชื่อคู่สัญญา (Counterparty's Name)
                      </Label>
                      <Label className="content-val">
                        {requestTemplateDetail.counterparty_name || "-"}
                      </Label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row id="section-page-5-1">
                <Col md={12}>
                  <div className="body-content">
                    <Label className="content-name">
                    วัตถุประสงค์ของการเปิดเผยข้อมูล (Purpose)
                    </Label>
                    <Label className="content-val label-text-area">
                      {requestTemplateDetail.purpose || "-"}
                    </Label>
                  </div>
                </Col>
            </Row>
            <Row id="section-page-6-1">
              <Col md={12}>
                <div className="body-content">
                  <Label className="content-name">
                  เริ่มเปิดเผย/รับข้อมูลวันที่ (Beginning Date of Information Disclosure)
                  </Label>
                  <Label className="content-val">
                    { ConvertFormatDate(requestTemplateDetail.beginning_date) || "-"}
                  </Label>
                </div>
              </Col>
            </Row>
            <Row id="section-page-7-1">
              <div className="header-content">
                อื่นๆ (Others)
              </div>
              <Col md={12}>
                <div className="dashed-line"></div>
                <Row>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">ภาษา (Language)</Label>
                      <Label className="content-val">
                        {requestTemplateDetail.name_language || "-"}
                      </Label>
                    </div>
                  </Col>
                  <Col md={2}></Col>
                  <Col md={5}>
                    <div className="body-content">
                      <Label className="content-name">
                        ระดับชั้นความลับ (Confidentiality Level)
                      </Label>
                      <Label className="content-val">
                        {requestTemplateDetail.id_language === 1
                          ? requestTemplateDetail.name_confidential_level_th
                          : requestTemplateDetail.id_language === 2
                          ? requestTemplateDetail.name_confidential_level_en
                          : "-"}
                      </Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="body-content">
                      <Label className="content-name">
                        การเปิดเผย/ใช้/ประมวลผลข้อมูลส่วนบุคคลภายใต้เอกสารนี้<br/>
                        (Personal data will be disclosed/used/processed under this
                        document)
                      </Label>
                      <Label className="content-val">
                        {requestTemplateDetail.share_pdpa === "1" ? "Yes" : "No"}
                      </Label>
                    </div>
                    <div className="body-content">
                      <Label className="content-name">
                        ความเห็นของ User (User's Comment)
                      </Label>
                      <Label className="content-val word-wrap">
                        {requestTemplateDetail.user_comment || "-"}
                      </Label>
                    </div>
                    <div className="body-content">
                      <Label className="content-name">แนบเอกสารเพื่อพิจารณา (Attachment)</Label>
                      {considerDoc.length > 0 ? (
                        <MultipleDownloadfile
                          folder={requestDetail.request_no}
                          dataFile={considerDoc}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </div>
                    <div className="body-content">
                      <Label className="content-name">
                        ชื่อนักกฎหมายที่เคยตรวจเอกสารนี้ (Legal team who has handled
                        this work)
                      </Label>
                      <Label className="content-val">
                        {requestDetail.require_handled_by || "-"}
                      </Label>
                    </div>
                    <div className="body-content">
                      <Label className="content-name">
                      ผู้อนุมัติแบบคำขอ (User Approver)
                      </Label>
                      <Label className="content-val">
                        {requestDetail.approve_request_by || "-"}
                      </Label>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </DownloadPDF>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default AssignDetailNda;
